import Rex from '../../static/logo-rex.png';
import Redefy from '../../static/logo-redify.png';
import PurpleBricks from '../../static/logo-purplebricks.png';
import HomeBay from '../../static/logo-homebay.png';
import RedfinNow from '../../static/logo-redfinnow.png';

export default {
  Rex: {
    logo: Rex,
    description: 'Lowest fee. Full Service. Game-changing technology.',
  },
  Redefy: {
    logo: Redefy,
    description: 'Flat Fee. Full Service. Sell your home for $3000.*',
  },
  'Purple Bricks': {
    logo: PurpleBricks,
    description: 'The best knowledge in your area.',
  },
  HomeBay: {
    logo: HomeBay,
    description: '0% Commission. 100% Support. Sell Fast. Low Flat Fee‎',
  },
  RedfinNow: {
    logo: RedfinNow,
    description: 'Get an All-Cash offer for you home.',
  },
};
